/**
 * Loyalty, rewards & wallet — types and top-up constants only.
 *
 * The seeded `loyalty` balance (1,240 pts · Gold · 760 to Platinum) and the seeded
 * `rewards` catalogue were deleted. The screen fell back to them whenever
 * /api/ui/screen/rewards-wallet failed or returned an empty catalogue, so a customer with
 * no points at all was shown a Gold-tier balance and four rewards they could "afford" —
 * points are a liability the restaurant has to honour at the counter.
 *
 * There is likewise no seeded wallet balance or transaction list: the wallet is real money
 * and reads only from the Web API (0 until a staff-confirmed top-up credits it).
 */

export type RewardIcon = 'percent' | 'dessert' | 'delivery' | 'rupee';

export interface Reward {
  id: string;
  title: string;
  sub: string;
  cost: number;
  icon: RewardIcon;
  tint: string;
  color: string;
}

/** Top-up amounts offered as one-tap buttons — UI options, not a customer's money. */
export const QUICK_ADD = [200, 500, 1000];
export const CASHBACK_MIN = 500;
export const CASHBACK_AMT = 50;
